/**
 * Created by Ning Jiang on 2022-04-01.
 */

import {DeadwoodRip} from "../DeadwoodRip";
import {XBetController} from "../xbet/XBetController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class BelowStakeWinRestriction {

    private static getBasePlayedBetValue():number {
        let betLevel = SlotGame.apiPlugin.freeBets.hasFreeBets() ? SlotGame.apiPlugin.freeBets.getBet() : SlotGame.apiPlugin.betLevel.getLevel();
        return DeadwoodRip.model.gameData?.playedBetValue || parseFloat(betLevel);
    }

    public static getBuyFeaturePrice():number {
        const activeBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();
        if(activeBetFeature) {
            return activeBetFeature.getTotalCost();
        }
        return BelowStakeWinRestriction.getBasePlayedBetValue();
    }

    // https://github.com/nolimitcity/nolimit-slot-launcher/issues/397
    public static isWinBelowStake():boolean {
        return SlotGame.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (DeadwoodRip.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static isWinBelowPlayedBetValue():boolean {
        if(!SlotGame.apiPlugin.gameClientConfiguration.belowStakeWinRestriction) {
            return false;
        }

        const activeBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();
        const price = activeBetFeature && XBetController.boostedNames.includes(activeBetFeature.name) ? activeBetFeature.getTotalCost() : BelowStakeWinRestriction.getBasePlayedBetValue();

        return DeadwoodRip.model.data.accumulatedRoundWin <= price;
    }
}